export const PATHS = {
    INSIGHT: 'insight',
    WELCOME: 'welcome-page',
    GRAPH_EXPLORER: 'entities-graph-explorer',
    PERIMETER_EXPOSURE: 'perimeter-exposure',
};
